import { styled } from "styled-components";

export const NumberPickerTabsWrapper = styled.div<{ $haveHeading?: boolean }>`
  width: 100%;
  display: flex;
  justify-content: center;
  margin: ${({ $haveHeading }) => ($haveHeading ? "24px 0 48px 0" : "48px 0")};
  padding: 0 12px;
`;

export const NumberPickerTabsContainer = styled.div`
  width: 100%;
  max-width: 1024px;
`;
